// src/routes/clientsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Clients from '../pages/clients/Clients';
import CreateClient from '../pages/clients/CreateClient';
import EditClient from '../pages/clients/EditClient';
import ProtectedRoute from '../components/global/ProtectedRoute';

const clientsRoutes = (
    <>
        {/* Clients List */}
        <Route
            path="/clients"
            element={
                <ProtectedRoute requiredPermission="clients.view">
                    <Clients />
                </ProtectedRoute>
            }
        />

        {/* Create Client */}
        <Route
            path="/clients/create"
            element={
                <ProtectedRoute requiredPermission="clients.create">
                    <CreateClient />
                </ProtectedRoute>
            }
        />

        {/* Edit Client */}
        <Route
            path="/clients/:id/edit"
            element={
                <ProtectedRoute requiredPermission="clients.update">
                    <EditClient />
                </ProtectedRoute>
            }
        />
    </>
);

export default clientsRoutes;